import * as React from 'react';

import Progress from "../../../common/organism/progress";
import {CustomerBlackList} from "../../../../domain/model/customer_black_list";
import {match as Match} from "react-router";
import CustomerBlackListEditComponent from "./customer_black_list_edit";

interface IProps {
    isInit: boolean;
    isLoading: boolean;
    match: Match<{action: string}>;
    customerBlackList: CustomerBlackList | null;
    anchorEl: any;
    handleClick: (event: any) => void;
    handleClose: () => void;
    handleAddCustomerBlackListSubmit: (values: any) => void;
    handleDeleteCustomerBlackListSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const CustomerBlackListComponent: React.FC<IProps> = (props) => {
    const {isInit, isLoading, customerBlackList,
        handleAddCustomerBlackListSubmit, handleDeleteCustomerBlackListSubmit} = props;

    // 初期化
    if (isInit) { return <Progress canAnimation={false}/>}

    return (
        <CustomerBlackListEditComponent
            isLoading={isLoading}
            customerBlackList={customerBlackList}
            handleAddCustomerBlackListSubmit={handleAddCustomerBlackListSubmit}
            handleDeleteCustomerBlackListSubmit={handleDeleteCustomerBlackListSubmit}
        />
    );
};

export default CustomerBlackListComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/black_list/customer_black_list.tsx